import { Data_getInstance2o7c2m6692afy as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { CreateSecretMutationSelections_getInstancewalai12czjs9 as CreateSecretMutationSelections_getInstance } from './selections/CreateSecretMutationSelections.mjs';
import { CreateSecretMutation_VariablesAdapter_instance159o51cg8r2j3 as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.o6h_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.o6h_1) + ')';
      }
      hashCode() {
        return this.o6h_1 == null ? 0 : this.o6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.o6h_1, other.o6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.p6h_1 = secretId;
        this.q6h_1 = description;
        this.r6h_1 = createdTimestamp;
        this.s6h_1 = lastUsedTimestamp;
        this.t6h_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.p6h_1.toString() + ', description=' + this.q6h_1 + ', createdTimestamp=' + this.r6h_1.toString() + ', lastUsedTimestamp=' + toString(this.s6h_1) + ', secretToken=' + this.t6h_1 + ')';
      }
      hashCode() {
        var result = this.p6h_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.q6h_1) | 0;
        result = imul(result, 31) + this.r6h_1.hashCode() | 0;
        result = imul(result, 31) + (this.s6h_1 == null ? 0 : this.s6h_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.t6h_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.p6h_1.equals(other.p6h_1))
          return false;
        if (!(this.q6h_1 === other.q6h_1))
          return false;
        if (!this.r6h_1.equals(other.r6h_1))
          return false;
        if (!equals(this.s6h_1, other.s6h_1))
          return false;
        if (!(this.t6h_1 === other.t6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u6h_1 = obj(Data_getInstance());
        this.v6h_1 = (new (Builder())('data', Companion_getInstance().g6h_1)).p46(CreateSecretMutationSelections_getInstance().z6h_1).e3a();
        this.w6h_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.x6h_1 = 'createSecret';
      }
      j6h() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.a6i_1 = input;
      }
      l6h() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.l6h();
      }
      i4a() {
        return Companion_getInstance_0().j6h();
      }
      m6h() {
        return 'createSecret';
      }
      operationName() {
        return this.m6h();
      }
      m49(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.b6i(writer, this, customScalarAdapters, withDefaultValues);
      }
      l49() {
        return Companion_getInstance_0().u6h_1;
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.a6i_1.toString() + ')';
      }
      hashCode() {
        return this.a6i_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.a6i_1.equals(other.a6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
